import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import InquiryModal from '../../components/features/InquiryModal';

const Support = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const supportSections = [
        {
            title: '📖 사용 매뉴얼',
            desc: '기능별 상세 사용법을 확인하세요.',
            link: '/support/manual',
            status: '준비중'
        },
        {
            title: '🛠 트러블슈팅',
            desc: '자주 발생하는 문제와 해결 방법.',
            link: '/support/troubleshooting',
            status: '준비중'
        },
        {
            title: '❓ 자주 묻는 질문',
            desc: '도입 전 궁금한 내용을 모았습니다.',
            link: '/support/faq',
            status: '준비중'
        }
    ];

    const openSupportInquiry = (e) => {
        e.preventDefault();
        setIsModalOpen(true);
    };

    return (
        <div className="support-page" style={{ paddingBottom: '6rem' }}>
            <div className="page-hero">
                <div className="container">
                    <h1 className="page-title">지원센터</h1>
                    <p className="page-subtitle">
                        기존 고객님들을 위한 기술 지원 공간입니다.<br />
                        필요한 자료를 찾아보세요.
                    </p>
                </div>
            </div>

            <div className="container">
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
                    {supportSections.map((item, index) => (
                        <div key={index} style={{
                            padding: '2.5rem',
                            border: '1px solid var(--border-color)',
                            borderRadius: '12px',
                            backgroundColor: 'white'
                        }}>
                            <h3 style={{ marginBottom: '1rem', fontSize: '1.4rem' }}>{item.title}</h3>
                            <p style={{ color: 'var(--text-light)', marginBottom: '2rem', height: '40px' }}>{item.desc}</p>

                            {item.status === '준비중' ? (
                                <button disabled className="btn btn-outline" style={{ opacity: 0.5, cursor: 'not-allowed', width: '100%' }}>
                                    문서 준비중
                                </button>
                            ) : (
                                <Link to={item.link} className="btn btn-outline" style={{ width: '100%', display: 'block', textAlign: 'center' }}>
                                    바로가기
                                </Link>
                            )}
                        </div>
                    ))}
                </div>

                <div style={{ marginTop: '4rem', padding: '2rem', backgroundColor: '#f8f9fa', borderRadius: '12px', textAlign: 'center' }}>
                    <h3>원하는 내용이 없으신가요?</h3>
                    <p style={{ margin: '1rem 0' }}>지원센터에서 해결되지 않는 문제는 직접 문의해주세요.</p>
                    <button onClick={openSupportInquiry} className="btn btn-primary" style={{ display: 'inline-block' }}>기술지원 문의하기</button>
                </div>
            </div>

            <InquiryModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                type="SUPPORT"
            />
        </div>
    );
};

export default Support;
